import { render, staticRenderFns } from "./Advertiser.vue?vue&type=template&id=0a835cca&scoped=true&"
import script from "./Advertiser.vue?vue&type=script&lang=js&"
export * from "./Advertiser.vue?vue&type=script&lang=js&"
import style0 from "./Advertiser.vue?vue&type=style&index=0&id=0a835cca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a835cca",
  null
  
)

export default component.exports